import { useState } from 'react';

function useDirtyData(init, keepEmptyValues) {
  const [data, setData] = useState(init);

  function saveData(item) {
    setData(item);
  }
  function removeData(item) {
    delete data[item];
  }

  return {
    data,
    isEmpty() {
      const isEmpty =
        Object.entries(data).length === 0 && data.constructor === Object;
      return isEmpty;
    },
    processDirtyData(attribute, val, initialVal) {
      if (val === initialVal || (!keepEmptyValues && val === '')) {
        removeData(attribute);
      } else {
        saveData(Object.assign(data, { [attribute]: val }));
      }
    },
  };
}

export default useDirtyData;
